






















































































































import { plainToInstance } from 'class-transformer'
import { Component, Prop } from 'vue-property-decorator'

import { errorNotificationWrapper } from '../../../../../../../../../logic/helpers/NotificationService'
import {
  ChannelInfo,
  ErrorChannelInfo,
  SuccessChannelInfo
} from '../../../../../../../../../models/CheckChannels/CheckChannels'
import { UseFields } from '../../../../../../../../Pi'
import { FieldData } from '../../../../../../../../Pi/types'
import CustomEditor from '../../../../../Editor/CustomEditor'
import ChannelsInfoHelper from '../../../../../Helpers/ChannelsInfoHelper'
import { CheckSubscriptionNode } from '../../logic/CheckSubscriptionNode'

@Component({
  data() {
    return {
      ErrorChannelInfo,
      SuccessChannelInfo,
    }
  }
})
export default class CheckSubscriptionSidebar extends UseFields {
  @Prop() node!: CheckSubscriptionNode

  @Prop() editor!: CustomEditor

  channelId = ''

  searchText = ''

  inputTemplate = 0

  isLoading = false

  get tableChannels(): Array<ChannelInfo> {
    return [
      ...this.node.errorChannelInfo.map((t) => {
        return ChannelsInfoHelper.GetChannel(t) as ChannelInfo
      }),
      ...this.node.data.targets
        .filter(t => !!t)
        .map((t) => {
          const isTarget = this.node.nodeProps.targets().find((bt) => bt.id === t)

          if (isTarget) {
            return plainToInstance(SuccessChannelInfo, {
              status: true,
              info: {
                id: isTarget.id,
                login: isTarget.login,
                title: isTarget.title,
                type: 'channel'
              }
            })
          }

          const channel = ChannelsInfoHelper.GetChannel(t!.toString())

          if (!channel?.status) {
            return plainToInstance(ErrorChannelInfo, channel)
          } else {
            return plainToInstance(SuccessChannelInfo, channel)
          }
        })
        .filter((c, index, arr) => !(c instanceof ErrorChannelInfo && arr.some(a => a.value === c.value)))
    ]
  }

  get searchResult(): Array<string> {
    return this.node.nodeProps.targets()
      .filter((a) => {
        const { title, id } = a
        const titleIncludeVal = title.toLowerCase().includes(this.searchText.trim().toLowerCase())
        const idIncludeSearchVal = String(id).includes(this.searchText)
        const idIsNotSelect = !this.node.data.targets.includes(id)

        if ((titleIncludeVal || idIncludeSearchVal) && idIsNotSelect) {
          return true
        }
      })
      .map(({ title }) => title)
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  setTarget(): void {
    this.isLoading = true

    if (this.channelId) {
      const isKnownChannel = ChannelsInfoHelper.GetChannel(this.channelId)

      if (isKnownChannel) {
        if (isKnownChannel instanceof SuccessChannelInfo) {
          this.node.setTarget(isKnownChannel.info.id)
        }
        if (isKnownChannel instanceof ErrorChannelInfo) {
          this.node.setErrorChannelInfo(isKnownChannel.value)
        }

        this.channelId = ''
        this.isLoading = false
      } else {
        this.editor.getChannelsInfo([ this.channelId ])
          .then(({ data }) => {
            if (data.length) {
              const [ info ] = data
              if (info instanceof SuccessChannelInfo) {
                this.node.setTarget(info.info.id)
              } else {
                this.node.setErrorChannelInfo(info.value)
              }
            }
          })
          .finally(() => {
            this.channelId = ''
            this.isLoading = false
          })
          .catch(() => this.isLoading = false)
      }
    }
  }

  selectOption(value: string): void {
    this.node.setTarget(this.node.nodeProps.targets().find(({ title }) => title === value)!.id)

    this.$nextTick(() => {
      this.channelId = ''
      this.inputTemplate += 1
    })
  }

  setTime(arg: FieldData): FieldData {
    arg.setter = (val) => {
      this.node.setTime(val)
    }
    return arg
  }

  retestChannel(value: string): void {
    this.isLoading = true
    this.editor.getChannelsInfo([ value ])
      .then(({ data }) => {
        if (data.length) {
          const [ info ] = data
          if (info instanceof SuccessChannelInfo) {
            this.node.setTarget(info.info.id)
            this.node.removeErrorTarget(value)
          } else {
            errorNotificationWrapper(this.$t('error').toString(), 'Информация о канале/чате получить не удалось')
          }
        }
      })
      .finally(() => this.isLoading = false)
      .catch(() => this.isLoading = false)
  }

  removeTarget(target: ChannelInfo): void {
    if (target instanceof SuccessChannelInfo) {
      this.node.removeTarget(target.info.id)
    }

    if (target instanceof ErrorChannelInfo) {
      this.node.removeErrorTarget(target.value)
    }
  }
}
